import Client from "../client";

const controllerName = "ChangeLog";
export class NoticeChangeLog {
  static async list(objectId: string): Promise<any> {
    return await Client.get(`notice/${objectId}/${controllerName}`);
  }
}
